import React from "react";
import { ICouponPartnerShare } from "../../interfaces";

/** The busiest partner, with the full split on hover. */
export const PartnerCell: React.FC<{ partners: ICouponPartnerShare[] }> = ({
  partners,
}) => {
  if (!partners.length) return <span className="text-muted">—</span>;
  const [top, ...rest] = partners;
  const label = (p: ICouponPartnerShare) => p.name ?? p.partnerId.slice(0, 8);
  return (
    <span
      title={partners
        .map((p) => `${label(p)}: ${p.attempts} tried, ${p.applied} worked`)
        .join("\n")}
    >
      {label(top)}
      {rest.length > 0 && <span className="text-muted"> +{rest.length}</span>}
    </span>
  );
};
